var map = {
	"./bianco-xxl.png": "de47",
	"./bianco.png": "9a48",
	"./mojito-xxl.png": "fd6d",
	"./mojito.png": "83dc",
	"./moscato-xxl.png": "1ef5",
	"./moscato.png": "101f",
	"./passionfruit-grapefruit-xxl.png": "855b",
	"./passionfruit-grapefruit.png": "3dde",
	"./passionfruit-pineapple-xxl.png": "99fe",
	"./passionfruit-pineapple.png": "3dcb",
	"./pomegranat-grapefruit-xxl.png": "9936",
	"./pomegranat-grapefruit.png": "80e7",
	"./rose-xxl.png": "29a1",
	"./rose.png": "cf9e",
	"./sangria-bianco-xxl.png": "fe2c",
	"./sangria-bianco.png": "6f56",
	"./sangria-tinto-xxl.png": "f9ac",
	"./sangria-tinto.png": "6e6f",
	"./strawberry-raspberry-xxl.png": "2858",
	"./strawberry-raspberry.png": "b6d1",
	"./vermouth-bianco-xxl.png": "37e3",
	"./vermouth-bianco.png": "55a9",
	"./vermouth-rosso-xxl.png": "24b9",
	"./vermouth-rosso.png": "fe42",
	"./violetto-xxl.png": "4d5c",
	"./violetto.png": "eaf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09ae";